import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';

const STAFFING_BOARD_API = '/api/v1/staffing-board';

// ─── Types ───────────────────────────────────────────────────────────────────

export interface ReadinessOverride {
  id: number;
  project: number | null;
  actor: number | null;
  actor_name: string;
  action: 'dispatched_with_warnings' | 'dispatched_with_blockers' | 'acknowledged_warnings';
  reason: string;
  preflight_snapshot: {
    summary: Record<string, number>;
    project?: Record<string, unknown>;
  };
  created_at: string;
}

export const OVERRIDE_ACTION_LABELS: Record<ReadinessOverride['action'], string> = {
  dispatched_with_warnings: 'Dispatched with warnings',
  dispatched_with_blockers: 'Dispatched with blockers',
  acknowledged_warnings: 'Acknowledged warnings',
};

// ─── Query ───────────────────────────────────────────────────────────────────

export function useReadinessOverrides(projectId?: number, enabled = true) {
  return useQuery<ReadinessOverride[]>({
    queryKey: [...queryKeys.staffingBoard.all, 'readiness-overrides', projectId ?? 'all'],
    queryFn: async () => {
      const params = projectId ? `?project_id=${projectId}` : '';
      const response = await apiClient.get<ReadinessOverride[]>(
        `${STAFFING_BOARD_API}/readiness_overrides/${params}`,
      );
      return response.data;
    },
    enabled,
  });
}
